module.exports = __webpack_public_path__ + "fonts/DM_Sans-600-latin-ext12.49935c4.woff2";